import { BrowserRouter as Router, Switch } from "react-router-dom";

import LoginPage from "features/auth/screens/login";
import PrivateRoute from "./privateRoute";
import ErrorPage from "features/shared/screens/error";
import PanelManagementPage from "features/panelManagement/shared/screens/panelManagement";
import TagRouter from "features/tagEdit/routers/tagRouter";
import ArticleRouter from "features/article/routers/articleRouter";
import ProductRouter from "features/product/routers/productRouter";
import AdminDashboardRouter from "features/adminDashboard/routers/adminDashboardRouter";
import RouteWithErrorBoundary from "./routeWithErrorBoundary";

const MainRouter = () => {
    return (
        <Router>
            <Switch>
                <PrivateRoute path="/panel-management" withNavbar={false}>
                    <PanelManagementPage />
                </PrivateRoute>
                <PrivateRoute path="/tag-editor" withNavbar={false}>
                    <TagRouter />
                </PrivateRoute>
                <PrivateRoute path="/inventory-editor" withNavbar={false}>
                    <ProductRouter />
                </PrivateRoute>
                <PrivateRoute path="/article-editor" withNavbar={false}>
                    <ArticleRouter />
                </PrivateRoute>
                <PrivateRoute path="/dashboard" withNavbar={false}>
                    <AdminDashboardRouter />
                </PrivateRoute>
                <RouteWithErrorBoundary
                    exact
                    path={["/", "/login"]}
                    component={LoginPage}
                />
                <RouteWithErrorBoundary path="*" component={ErrorPage} />
            </Switch>
        </Router>
    );
};

export default MainRouter;
